import { render } from "./SortSelect.vue?vue&type=template&id=5c72c11a&scoped=true"
import script from "./SortSelect.vue?vue&type=script&lang=js"
export * from "./SortSelect.vue?vue&type=script&lang=js"

import "./SortSelect.vue?vue&type=style&index=0&id=5c72c11a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c72c11a"]])

export default __exports__